import { j as n } from "./atoms-v218.js";
import { forwardRef as ie, useContext as se, useState as M, useMemo as C, useRef as N, useEffect as _, useId as re } from "react";
import le from "./atoms-v2127.js";
import { Icon as oe } from "./atoms-v217.js";
import { InputContainer as ae } from "./atoms-v2114.js";
import { InputHelper as $ } from "./atoms-v220.js";
import { InputInterior as ce } from "./atoms-v2128.js";
import { InputLabel as ue } from "./atoms-v2129.js";
import { InputOutline as de } from "./atoms-v223.js";
import { FormGroupContext as me } from "./atoms-v2130.js";
import { Checkbox as pe } from "./atoms-v29.js";
import { RSWrapper as fe, IconContainer as xe, ErrorIcon as he, OptionContainer as be, OptionLabel as G, MenuContainer as je, ContentWrapper as H, SelectedText as q, TagDividerContainer as ge, TagForRemove as Ie, Divider as we } from "./atoms-v2131.js";
import { DropdownSkeleton as ye } from "./atoms-v2132.js";
import { breakpoints as W } from "./atoms-v2125.js";
import { useOverlayScrollbars as Se } from "./atoms-v2133.js";
import { c as S } from "./atoms-v2134.js";
const E = (e) => e.flatMap((i) => "options" in i ? i.options : i), J = (e, i) => Array.isArray(e) && e.length === i.length, Ae = (e) => e.map((i) => "options" in i ? { mainLabel: i.label, options: i.options } : i);
function K(e, i) {
  const t = e.getBoundingClientRect(), s = i ? e.parentElement.parentElement.parentElement.getBoundingClientRect() : e.parentElement.getBoundingClientRect();
  return t.top < s.bottom && t.bottom > s.top && t.left < s.right && t.right > s.left;
}
const ve = (e, i, t) => {
  const { selectProps: s } = e, u = s.isMulti, l = e.data.value === "select-all", p = "subLabel" in e.data ? e.data.subLabel : null, b = "mainLabel" in e.data ? e.data.mainLabel : null, o = E(s.options).filter((m) => m.value !== "select-all"), f = l ? J(s.value, o) : e.isSelected, d = N(null);
  _(() => {
    const m = d.current, x = e.isFocused || e.isSelected;
    if (!m || !x)
      return;
    let a = 0, j = 0;
    const g = 30, I = () => {
      j += 1, !K(m, t) && (m.scrollIntoView({ block: "nearest" }), !K(m, t) && j < g && (e.isFocused || e.isSelected) && (a = requestAnimationFrame(I)));
    };
    return a = requestAnimationFrame(I), () => cancelAnimationFrame(a);
  }, [e.isFocused, e.isSelected, t]);
  const F = re();
  return /* @__PURE__ */ n.jsx(
    S.Option,
    {
      ...e,
      innerRef: (m) => {
        var x;
        d.current = m, (x = e.innerRef) == null || x.call(e, m);
      },
      children: /* @__PURE__ */ n.jsxs(be, { $colorTheme: i, $isFocused: e.isFocused, $isSelected: f, children: [
        u && /* @__PURE__ */ n.jsx(pe, { defaultChecked: f, id: F }, f ? "checked" : "unchecked"),
        /* @__PURE__ */ n.jsx(G, { $colorTheme: i, children: b }),
        p && /* @__PURE__ */ n.jsx(G, { $colorTheme: i, $isRight: !0, children: p })
      ] })
    }
  );
}, $e = (e, i) => {
  const { children: t } = e;
  return /* @__PURE__ */ n.jsx(S.Menu, { ...e, children: /* @__PURE__ */ n.jsx(je, { $colorTheme: i, children: t }) });
}, Fe = (e) => {
  const { children: i, innerProps: t, ...s } = e, u = s.isMulti, l = s.getValue();
  if (!u) {
    const o = Array.isArray(l) && l.length > 0 ? l[0] : l, f = (o == null ? void 0 : o.mainLabel) || "";
    return /* @__PURE__ */ n.jsxs(S.ValueContainer, { ...s, ...t, children: [
      /* @__PURE__ */ n.jsx(H, { $isMultiSelect: u, children: /* @__PURE__ */ n.jsx(q, { $hasTag: !1, $isDisabled: e.isDisabled, children: f }) }),
      Array.isArray(i) ? i[i.length - 1] : null
    ] });
  }
  const p = (o) => {
    o.preventDefault(), o.stopPropagation(), s.clearValue();
  }, b = l.map((o) => o.mainLabel).join(", ");
  return /* @__PURE__ */ n.jsxs(S.ValueContainer, { ...s, ...t, children: [
    /* @__PURE__ */ n.jsxs(H, { $isMultiSelect: u, children: [
      /* @__PURE__ */ n.jsx(q, { $hasTag: l.length > 0, children: b }),
      l.length > 0 && /* @__PURE__ */ n.jsxs(ge, { children: [
        /* @__PURE__ */ n.jsx(
          "div",
          {
            "aria-label": "Clear selections",
            onClick: p,
            onKeyDown: (o) => {
              (o.key === "Enter" || o.key === " ") && p(o);
            },
            onMouseDownCapture: p,
            onPointerDownCapture: p,
            onTouchStartCapture: p,
            role: "button",
            style: { cursor: "pointer", display: "inline-block" },
            tabIndex: 0,
            children: /* @__PURE__ */ n.jsx(Ie, { onRemove: () => s.clearValue(), children: l.length })
          }
        ),
        /* @__PURE__ */ n.jsx(we, {})
      ] })
    ] }),
    Array.isArray(i) ? i[1] : null
  ] });
}, ke = (e) => {
  const { children: i } = e, t = N(null), [s] = Se({
    options: {
      overflow: {
        x: "hidden",
        y: "scroll"
      }
    }
  });
  return _(() => {
    t.current && s(t.current);
  }, [s]), /* @__PURE__ */ n.jsx(
    S.MenuList,
    {
      ...e,
      innerRef: (u) => {
        t.current = u;
      },
      children: i
    }
  );
}, De = {
  control: (e) => ({
    ...e,
    background: "transparent",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
    height: "46px",
    padding: 0,
    [`@media ${W.medium}`]: {
      height: "56px"
    }
  }),
  indicatorsContainer: () => ({ display: "none" }),
  menu: (e) => ({
    ...e,
    boxShadow: "none",
    marginBottom: "2px",
    marginTop: "2px"
  }),
  menuList: (e) => ({
    ...e,
    maxHeight: "205px",
    minHeight: "auto",
    width: "100%"
  }),
  multiValue: () => ({}),
  option: (e) => ({
    ...e,
    "&:hover": { background: "transparent" },
    alignItems: "center",
    background: "transparent",
    padding: 2,
    width: "100%"
  }),
  placeholder: () => ({}),
  valueContainer: () => ({
    boxSizing: "border-box",
    display: "flex",
    height: "100%",
    overflow: "hidden",
    padding: "22px 18px 8px",
    width: "100%",
    [`@media ${W.medium}`]: {
      padding: "26px 18px 8px"
    }
  })
}, Oe = ie(
  ({
    ariaHidden: e = !1,
    className: i,
    colorTheme: t = "light",
    defaultValue: s = [],
    disabled: u = !1,
    error: l,
    hasErrorIcon: p = !1,
    helperText: b,
    id: o,
    isDefaultEnabled: f = !1,
    isMultiSelect: d = !1,
    isSkeleton: F = !1,
    label: m,
    name: x,
    onChange: a,
    options: j = [],
    readOnly: g = !1,
    selectAllLabel: I,
    variant: y = "productive",
    ...Q
  }, U) => {
    const { isGroupedInput: k } = se(me), [D, V] = M(!1), A = C(() => {
      const r = Ae(j);
      return !d && f ? [{ isDisabled: !0, mainLabel: "", value: "" }, ...r] : I && d ? [{ mainLabel: I, value: "select-all" }, ...r] : r;
    }, [j, d, f, I]), X = C(() => {
      const r = E(A);
      if (d) {
        const c = Array.isArray(s) ? s : [s];
        return c.includes("select-all") ? r.filter((h) => h.value !== "select-all") : c.map((h) => r.find((v) => v.value === h)).filter(Boolean);
      }
      return Array.isArray(s) ? r.find((c) => c.value === s[0]) || null : r.find((c) => c.value === s) || null;
    }, [s, A, d]), [w, O] = M(X), B = `${x}_errormessage`, Y = d ? Array.isArray(w) && w.length > 0 : !!w, { onBlur: R, onFocus: L, ...Z } = Q, [T, P] = M(!1), z = j.some((r) => "options" in r), ee = C(
      () => ({
        DropdownIndicator: () => null,
        Menu: (r) => $e(r, t),
        MenuList: (r) => ke(r),
        MultiValue: () => null,
        Option: (r) => ve(r, t, z),
        Placeholder: () => null,
        ValueContainer: Fe
      }),
      [t, z]
    );
    return F ? /* @__PURE__ */ n.jsx(ye, { helperText: b, variant: y }) : /* @__PURE__ */ n.jsxs(ae, { "aria-hidden": e, className: i, variant: y, children: [
      /* @__PURE__ */ n.jsxs(
        de,
        {
          colorTheme: t,
          isDisabled: u || g,
          isErrored: !!l,
          isFocused: (T || D) && !g,
          isGroupedInput: k,
          variant: y,
          children: [
            /* @__PURE__ */ n.jsx(
              ue,
              {
                colorTheme: t,
                hasValue: Y,
                htmlFor: o || x,
                isDisabled: u,
                variant: y,
                children: m
              }
            ),
            /* @__PURE__ */ n.jsxs(ce, { children: [
              /* @__PURE__ */ n.jsx(fe, { ref: U, children: /* @__PURE__ */ n.jsx(
                le,
                {
                  ...Z,
                  closeMenuOnSelect: !d,
                  components: ee,
                  hideSelectedOptions: !1,
                  inputId: o || x,
                  isDisabled: u,
                  isMulti: d,
                  isSearchable: !1,
                  menuIsOpen: D,
                  menuPlacement: "auto",
                  onBlur: (r) => {
                    R == null || R(r), P(!1);
                  },
                  onChange: (r) => {
                    if (d) {
                      const c = r;
                      if ((c == null ? void 0 : c.some((h) => h.value === "select-all")) || !1) {
                        const h = E(A).filter((te) => te.value !== "select-all"), v = J(w, h) ? [] : h;
                        O(v), a == null || a(v);
                        return;
                      }
                    } else {
                      const c = r === w ? null : r;
                      O(c), a == null || a(c);
                      return;
                    }
                    O(r), a == null || a(r);
                  },
                  onFocus: (r) => {
                    L == null || L(r), P(!0);
                  },
                  onMenuClose: () => V(!1),
                  onMenuOpen: () => !g && V(!0),
                  options: A,
                  styles: De,
                  value: w
                }
              ) }),
              /* @__PURE__ */ n.jsxs(
                xe,
                {
                  $colorTheme: t,
                  $isDisabled: u || g,
                  $variant: y,
                  children: [
                    l && p ? /* @__PURE__ */ n.jsx(he, { $colorTheme: t, name: "warning-filled", size: "medium" }) : null,
                    /* @__PURE__ */ n.jsx(oe, { name: D ? "chevron-up" : "chevron-down", size: "medium" })
                  ]
                }
              )
            ] }),
            k ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
              /* @__PURE__ */ n.jsx($, { isGroupedInput: !0, colorTheme: t, children: !l && b }),
              /* @__PURE__ */ n.jsx($, { isError: !0, isGroupedInput: !0, colorTheme: t, id: B, children: l })
            ] }) : null
          ]
        }
      ),
      k ? null : /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
        /* @__PURE__ */ n.jsx($, { colorTheme: t, children: !l && b }),
        /* @__PURE__ */ n.jsx($, { isError: !0, colorTheme: t, id: B, children: l })
      ] })
    ] });
  }
);
Oe.displayName = "Dropdown";
export {
  Oe as Dropdown,
  $e as Menu,
  ke as MenuList,
  ve as OptionComponent,
  Fe as ValueContainer,
  De as customStyles
};
